import React from 'react';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const AccessDenied = ({ 
  title = "Kein Zugriff", 
  message = "Kein Zugriff. Bitte wenden Sie sich an den Innendienst.",
  showBackButton = true 
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="max-w-md w-full mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
              <Shield className="w-8 h-8 text-red-600" />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-4">
            {title}
          </h1>
          
          <p className="text-slate-600 mb-8">
            {message}
          </p>

          {showBackButton && (
            <div className="space-y-4">
              <Link to="/">
                <Button className="w-full bg-emerald-600 hover:bg-emerald-700">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Zurück zum Dashboard
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;